import { SwipeableDrawer } from "@mui/material";
import type { FC } from "react";
import { SwapStaff } from "../../../components/SwapStaff/SwapStaff";
import { useHandleNurseChange } from "../../../hooks/useHandleNurseChange";
import { useScheduleDayOf } from "../../../hooks/useScheduleDayOf";
import type { NurseInShift } from "../../../utils/models";

interface SwapDrawerProps {
	open: boolean;
	onClose: () => void;
	shift: NurseInShift | null;
}

const SwapDrawer: FC<SwapDrawerProps> = ({ open, onClose, shift }) => {
	const { swapBetweenShifts } = useHandleNurseChange();
	const scheduleDayOf = useScheduleDayOf();
	if (!shift) {
		return null;
	}

	return (
		<SwipeableDrawer
			data-testid="swap-drawer"
			anchor="bottom"
			onOpen={() => {}}
			open={open}
			onClose={onClose}
			slotProps={{
				paper: {
					sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16 },
				},
			}}
		>
			<SwapStaff
				date={scheduleDayOf(shift).date}
				onClose={onClose}
				shift={shift}
				handleSwap={async (originShiftId, targetShiftId) => {
					await swapBetweenShifts({ originShiftId, targetShiftId });
					onClose();
				}}
			/>
		</SwipeableDrawer>
	);
};

export default SwapDrawer;
